// Tuning values for snapping, in scene units unless the name says otherwise.

// The snap range every snapping strategy but the facing snap measures from.
export const DEFAULT_SNAPPING_DISTANCE = 21;

// The facing snap's range: a filler or panel snaps from up to this far.
export const FILLER_SNAPPING_DISTANCE = 22;

// How far apart two uppers may be on the other axis and still be treated as
// neighbours: a side join needs them roughly level in depth, a back join
// needs them roughly in line across the width.
export const UPPER_SNAP_MAX_CROSS_AXIS_GAP = 30;

// How close two edges of an upper L-shaped corner's parts must be to count
// as one face, when finding the ends of its legs.
export const END_FACE_EPSILON = 4;

// Without adjustable legs, how far a kick-length panel's face sits behind the
// carcase face.
export const KICK_PANEL_SETBACK_MM = 25;

// Scene units per millimetre, for the measurements kept in millimetres.
export const SCENE_UNITS_PER_MM = 0.2;
